import { useStore } from '../zustand';

export const sendAnalyticsData = async ({ event_type }) => {
    const variant_id = useStore.getState().variant_id;
    const { vList } = useStore.getState().variants_payload;
    const { product_session_id, variant_session_id, viewer_session_id, origin, viewer_type, store_id, levar_session_token } = useStore.getState().settings;
    
    const analyticsData = {
        created_at: (new Date()).toISOString(),
        event_type: event_type,
        product_session_id: product_session_id,
        variant_session_id: variant_session_id,
        viewer_session_id: viewer_session_id,
        store_id: store_id,
        ardt: vList[variant_id].ardt,
        origin: origin,
        asset_stage: vList[variant_id].stage,
        asset_status: vList[variant_id].status,
        asset_theme: viewer_type,
        variant_id: variant_id,
        product_id: vList[variant_id].product_id,
        referrer: vList[variant_id].referer,
        device_type: window.navigator.userAgent,
        domain: window.location.href,
        levar_session_token: levar_session_token
    }

    // console.log('analyticsData', analyticsData)

    // console.log('analyticsData', analyticsData);

    // TODO: Change to env file location check every instance of it working
    // const url = "https://jb6ypklxab.execute-api.us-east-1.amazonaws.com/dev/"; // Production
    const url = "https://be9ylitupj.execute-api.us-east-1.amazonaws.com/dev/" // Staging

    const options = {
        method: "POST",
        body: JSON.stringify(analyticsData),
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        const response = await fetch(url, options)
        if(!response.ok) { throw new Error(`New Fetch Call Cannot Be Made`) };
        const data = await response.json();
        return data;
    } catch (e) {
        console.log('error', e);
    };
};
